// User-related socket actions

export const createUserActions = (store) => {
  return {
    // USERS
    addOrUpdateUserData(value) {
      store.currentUser = value;
      store.isAdmin = value?.isAdmin;
    },

    resetUserData() {
      store.currentUser = undefined;
      store.isAdmin = false;
    },
  };
};
